import React, { FC } from "react";
import { NonEditableFormField } from "./FormFields";
import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { COUNTRY_OPTIONS } from "@/components/common/countryOptions";

const FIELD_STYLES = {
  container: "space-y-2",
  label: "text-sm font-medium text-gray-700",
  errorText: "text-sm text-red-500",
  errorBorder: "border-red-500",
} as const;

interface CountryFieldProps {
  selectedCountry: string;
  onSelect: (code: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
  className?: string;
  labelClassName?: string;
  contentClassName?: string;
  buttonClassName?: string;
  isEdit?: boolean;
  withLabel?: boolean;
}

export const CountryField: FC<CountryFieldProps> = ({
  selectedCountry,
  onSelect,
  label = "Country",
  placeholder = "Select a country",
  required = false,
  error,
  className,
  labelClassName,
  contentClassName,
  isEdit = true,
  withLabel = true,
  buttonClassName = "",
}) => {
  if (!isEdit) {
    return (
      <NonEditableFormField
        value={selectedCountry}
        isCopy={false}
        label={"Country"}
        labelClassName={labelClassName}
        contentClassName={contentClassName}
      />
    );
  }

  return (
    <div className={`${FIELD_STYLES.container} ${className || ""}`}>
      {withLabel && (
        <Label
          htmlFor="country"
          className={cn(FIELD_STYLES.label, labelClassName)}
        >
          {label} {required && "*"}
        </Label>
      )}

      <Select value={selectedCountry || undefined} onValueChange={onSelect}>
        <SelectTrigger
          id="country"
          aria-invalid={!!error}
          className={cn(
            "w-full justify-between",
            buttonClassName,
            contentClassName,
          )}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {COUNTRY_OPTIONS.map((country) => (
              <SelectItem key={country.value} value={country.value}>
                {country.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      {error && <p className="text-destructive text-sm">{error}</p>}
    </div>
  );
};
